import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { RotateCcw } from 'lucide-react';

interface FinalSignatureModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  onClear: () => void;
  title: string;
  signatureRef: React.RefObject<SignatureCanvas>; // Re-using for consistency, ensure it's passed correctly
}

const FinalSignatureModal: React.FC<FinalSignatureModalProps> = ({
  isOpen,
  onClose,
  onSave,
  onClear,
  title,
  signatureRef,
}) => {
  if (!isOpen) return null;

  const canvasWidth = 500;
  const canvasHeight = 200;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <div className="bg-white rounded-xl max-w-xl w-full p-6 shadow-xl">
        <h3 className="text-lg font-medium mb-4 text-gray-800 flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-[#40E0D0]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
          {title}
        </h3>
        <div className="mb-4 overflow-x-auto">
          <div className="border rounded relative bg-gray-50" style={{ width: `${canvasWidth}px`, height: `${canvasHeight}px` }}>
            <SignatureCanvas
              ref={signatureRef}
              canvasProps={{
                width: canvasWidth,
                height: canvasHeight,
                style: { width: `${canvasWidth}px`, height: `${canvasHeight}px` }
              }}
            />
            <button
              onClick={onClear}
              className="absolute top-2 right-2 p-1 bg-gray-100 rounded-full hover:bg-gray-200"
              title="Clear signature"
            >
              <RotateCcw size={16} />
            </button>
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            className="px-4 py-2 bg-[#2CB5A5] text-white rounded-md hover:bg-[#2CB5A5]/70"
          >
            Save Signature
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinalSignatureModal; 